import { render, staticRenderFns } from "./FactorSelector.vue?vue&type=template&id=6c3f4c07&scoped=true&"
import script from "./FactorSelector.vue?vue&type=script&lang=ts&"
export * from "./FactorSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3f4c07",
  null
  
)

export default component.exports